import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full bg-bg-main py-16 sm:py-24 px-4" data-id="element-131">
      <div className="max-w-3xl mx-auto text-center" data-id="element-132">
        <div className="text-5xl sm:text-6xl mb-6" data-id="element-133">🛡️</div>

        <h2 className="text-2xl sm:text-4xl font-serif font-black text-text-main mb-6 uppercase" data-id="element-134">
          7 Tage Geld-zurück-Garantie
        </h2>

        <p className="text-text-sec text-base sm:text-lg leading-relaxed font-medium max-w-2xl mx-auto mb-8" data-id="element-135">
          Teste SPORTUNTERRICHT FERTIG 7 Tage lang ohne Risiko. Wenn du merkst,
          dass das Material nicht zu dir passt, bekommst du dein Geld zurück.
          Eine kurze Nachricht reicht. Kein Stress. Kein Risiko.
        </p>

        <a href="#" className="text-primary font-medium text-sm hover:underline" data-id="element-136">
          Vollständige Rückgabebedingungen
        </a>
      </div>
    </section>;
}